import React, { useEffect, useState } from 'react';
import './loader.css';

const texts = ['Bienvenido ', 'Welcome', 'स्वागत', 'Salut', 'Privet', 'ନମସ୍କାର', 'أهلا بك', 'வரவேற்பு', 'Hola'];
function Loader({ loaderFinished, data="Hello", show2 }) {
    const [displayText, setDisplayText] = useState(data);
    const [textIndex, setTextIndex] = useState(0);
    const [loadFinished, setLoadFinished] = useState(false);
    const [translateY, setTranslateY] = useState(0);
    const [opacityLvl, setOpacityLvl] = useState(1);
    const [zIndexV, setzIndexV] = useState(15);
    
    useEffect(() => {
        const interval = setInterval(() => {
            if (show2) {
                if (textIndex === 0) {
                    setDisplayText(data);
                    // console.log("Index:",textIndex);
                    setTextIndex(textIndex + 1);
                } else if (textIndex <= texts.length) {
                    setDisplayText(texts[textIndex - 1]);
                    setTextIndex(textIndex + 1);
                    // console.log("Index:",textIndex);
                } else {
                    clearInterval(interval);
                    // console.log("Index:",textIndex);
                    setTimeout(() => {
                        setLoadFinished(true);
                    }, 500);
                }
            } else {
                clearInterval(interval);
                setTimeout(() => {
                    setLoadFinished(true);
                }, 1000);
            }
        }, show2 ? (textIndex === 0 ? 1000 : 200) : 800);

        return () => clearInterval(interval);
    }, [textIndex, show2, data]);
    // console.log("Index out:",textIndex);

    useEffect(() => {
        if (!loadFinished) {
            const translateYInterval = setInterval(() => {
                setTranslateY(prevTranslateY => {
                    if (prevTranslateY < 1) {
                        return prevTranslateY + 0.01;
                    }
                    return prevTranslateY;
                });
            }, 3);
            return () => clearInterval(translateYInterval);
        }else if(loadFinished){
            const translateYInterval = setInterval(() => {
                setTranslateY(prevTranslateY => {
                    if (prevTranslateY < 2) {
                        return prevTranslateY + 0.01;
                    }
                    return prevTranslateY;
                });
                setOpacityLvl(prevOpacityLvl => {
                    if(prevOpacityLvl > 0){
                        return prevOpacityLvl -0.01;
                    }
                    return prevOpacityLvl;
                })
                if(opacityLvl <= 0.01){
                    setzIndexV(0);
                }
                if(zIndexV === 0){
                    loaderFinished(true);
                };
            }, 3);
            return () => clearInterval(translateYInterval);
        }
    }, [loaderFinished, opacityLvl, loadFinished, zIndexV]);
    // console.log(loadFinished);
    // console.log(displayText)

    return (
        <div className='loader' style={{ transform: `scale(${translateY * 550}%)`, opacity: `${opacityLvl}`, zIndex: `${zIndexV}`}}>
            <div className="loader-text" style={{ boxShadow: `0px 0px ${translateY * 250}px ${translateY * 100}px rgba(0, 0, 0, 0.367)` }}>
                <span>{displayText}</span>
            </div>
        </div>
    )
}

export default Loader;
